var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-payment__order-details cog-col",
      class: [_vm.colNumClass]
    },
    [
      _c("table", [
        _vm.showLineItems
          ? _c(
              "tbody",
              { staticClass: "cog-payment__line-items" },
              [
                _vm._l(_vm.order.LineItems, function(lineItem) {
                  return [
                    _vm.renderGroup(lineItem.Group)
                      ? _c("tr", { key: _vm.getGroupKey(lineItem) }, [
                          _c(
                            "th",
                            {
                              attrs: {
                                id: _vm.getGroupId(lineItem.Group),
                                colspan: "2"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(lineItem.Group) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("tr", { key: _vm.getLineItemKey(lineItem) }, [
                      _c(
                        "td",
                        {
                          class: lineItem.Group
                            ? "cog-order-details__indented-line-item"
                            : null,
                          attrs: {
                            headers: lineItem.Group
                              ? _vm.getGroupId(lineItem.Group)
                              : null
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(lineItem.Name) +
                              "\n\t\t\t\t\t\t"
                          ),
                          lineItem.Description
                            ? _c(
                                "span",
                                { staticClass: "cog-label__description" },
                                [_vm._v(" " + _vm._s(lineItem.Description))]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          attrs: {
                            headers: lineItem.Group
                              ? _vm.getGroupId(lineItem.Group)
                              : null
                          }
                        },
                        [_vm._v(_vm._s(_vm.$format(lineItem.Amount, "C")))]
                      )
                    ])
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.renderSubtotal
          ? _c("tbody", { staticClass: "cog-payment__subtotal" }, [
              _c("tr", [
                _c("td", { staticClass: "cog-right" }, [
                  _vm._v(_vm._s(_vm.$resource("payment-subtotal")) + ":")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.$format(_vm.order.SubTotal || 0, "C")))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.Fees && _vm.filteredFees.length > 0
          ? _c(
              "tbody",
              { staticClass: "cog-fees" },
              _vm._l(_vm.filteredFees, function(fee) {
                return _c("tr", { key: _vm.getLineItemKey(fee) }, [
                  _c("td", { staticClass: "cog-right" }, [
                    _vm._v(_vm._s(fee.Name) + ":")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(fee.Amount ? _vm.$format(fee.Amount, "C") : "—")
                    )
                  ])
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.readonly &&
        _vm.order &&
        _vm.order.PaymentAccountStatus == _vm.PaymentAccountStatus.Active &&
        _vm.order.PaymentStatus != _vm.PaymentStatus.Pending &&
        _vm.order.AmountDue > 0
          ? _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "cog-right" }, [
                  _vm._v(_vm._s(_vm.$resource("order-amount-paid")) + ":")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s("(" + _vm.$format(_vm.order.AmountPaid, "C") + ")")
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "cog-right" }, [
                  _vm._v(_vm._s(_vm.$resource("order-balance-due-label")) + ":")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.$format(_vm.order.AmountDue, "C")))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tfoot", [
          _c("tr", [
            _c("td", { attrs: { colspan: "2" } }, [
              _c("div", { staticClass: "cog-order-details__total" }, [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.orderAmountLabel || "Order Amount") +
                    ": " +
                    _vm._s(
                      _vm.$format(
                        _vm.includeFees
                          ? _vm.order.OrderAmount || 0
                          : _vm.order.OrderAmount - _vm.order.ProcessingFees ||
                              0,
                        "C"
                      )
                    ) +
                    "\n\t\t\t\t\t"
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }